import CrudController from "./crud_controller";

export default class extends CrudController {
  connect() {
    this.siteNum = this.data.get("siteNum");
    this.loadList();
  }

  loadList() {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/phones`), this.listTarget)
      .then(html => {
        App.$iconify.scanDOM();
        if(window.App.EDIT_MODE) this.showNewLink();
      });
  }

  swap(event) {
    event.preventDefault();
    let seqNum = event.currentTarget.dataset.seqNum;
    let targetSeqNum = event.currentTarget.dataset.targetSeqNum;
    let controller = this;
    App.$rails.ajax({
      type: "PATCH",
      url: `/sites/${this.siteNum}/phones/${seqNum}/swap/${targetSeqNum}`,
      success(data) {
        controller.loadList();
      },
      error(data) {
        // TODO: Error handling.
        controller.loadList();
      }
    });
  }

  new(event) {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/phones/new`), this.listTarget)
      .then(() => {
        this.hideNewLink();
      });
  }

  edit(event) {

    let div = document.createElement("div");
        div.classList.add("circle-loader");

    let button = event.target.closest("button");

    button.replaceWith(div);

    this.clearMessage();
    let seqNum = event.currentTarget.dataset.seqNum;
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/phones/${seqNum}/edit`), this.listTarget)
      .then(() => {
        this.hideNewLink();
        div.replaceWith(button);
      });
  }
}